var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconSingle = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6 12.75C5.586 12.75 5.25 12.414 5.25 12C5.25 11.586 5.586 11.25 6 11.25H18C18.414 11.25 18.75 11.586 18.75 12C18.75 12.414 18.414 12.75 18 12.75H6Z", fill: "black" }),
            React.createElement("path", { d: "M14.4698 9.53024C14.1773 9.23774 14.1773 8.76224 14.4698 8.46974C14.7623 8.17724 15.2378 8.17724 15.5303 8.46974L18.5303 11.4697C18.8228 11.7622 18.8228 12.2377 18.5303 12.5302L15.5303 15.5302C15.2378 15.8227 14.7623 15.8227 14.4698 15.5302C14.1773 15.2377 14.1773 14.7622 14.4698 14.4697L16.9395 12L14.4698 9.53024Z", fill: "black" }))),
        alt: 'Icon Single',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconSingle;
//# sourceMappingURL=index.js.map